import { parse } from 'yaml';

import type { WorkflowView } from '@/lib/api/generated/model';

/**
 * Whether the chosen file's `key` matches a workflow already in the
 * workspace (spec 245 FR-001) — checked client-side, before any call to
 * either door, because the create door's 409 names only the clashing
 * workflow's display name, not the id the update door needs.
 *
 * Reads the file the same way `workflowOutline` does: a quick parse for
 * display, not full schema validation — the service remains the only
 * authority on whether the document is actually valid. A file that will not
 * parse, or that parses without a top-level `key`, has nothing to clash with.
 */
export async function keyClash(
  file: File,
  workflows: WorkflowView[],
): Promise<WorkflowView | null> {
  let document: unknown;
  try {
    document = parse(await file.text());
  } catch {
    return null;
  }
  if (typeof document !== 'object' || document === null) return null;
  const key = (document as { key?: unknown }).key;
  if (typeof key !== 'string' || key.length === 0) return null;

  return workflows.find((workflow) => workflow.key === key) ?? null;
}
